import React, { useState } from "react";

import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

import { Form, Stack, Button, InputGroup } from "react-bootstrap";
import { t } from "i18next";
import { Link } from "react-router-dom";
import { isValidEmail, isValidPassword } from "../../../../utils/validation";
import { gestioneSnackbar } from "../../../../utils/common";

import HeaderRegistration from "../../components/headerRegistration/HeaderRegistration";

const Step1 = ({
  name,
  setName,
  surname,
  setSurname,
  email,
  setEmail,
  password,
  setPassword,
  nextStep,
}) => {
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const [showErrorPassword, setShowErrorPassword] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!name || !surname) {
      return gestioneSnackbar(
        true,
        t("validation.name_surname_mandatory"),
        "error"
      );
    }
    if (!isValidEmail(email)) {
      return gestioneSnackbar(true, t("validation.email_not_valid"), "error");
    }
    if (!isValidPassword(password)) {
      setShowErrorPassword(true);
      return;
    } else {
      setShowErrorPassword(false);
    }

    nextStep();
  };

  return (
    <Stack gap={5} className="min-vh-100">
      <Stack
        className="d-flex justify-content-center align-items-center w-100 "
        gap={2}
      >
        <div className="text-start w">
          <HeaderRegistration
            title={t("common.welcome", { name: "" })}
            subtitle={t("registration.subtitle")}
          />
        </div>
        <Form onSubmit={(e) => handleSubmit(e)}>
          <Form.Group
            className="mb-3 input-registration-wrapper"
            controlId="formPlaintextName"
          >
            <Form.Control
              className="input-registration"
              maxLength={25}
              type="text"
              placeholder={t("common.name")}
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
          </Form.Group>
          <Form.Group
            className="mb-3 input-registration-wrapper"
            controlId="formPlaintextSurname"
          >
            <Form.Control
              className="input-registration"
              maxLength={25}
              type="text"
              placeholder={t("common.surname")}
              value={surname}
              onChange={(e) => setSurname(e.target.value)}
              required
            />
          </Form.Group>
          <Form.Group
            className="mb-3 input-registration-wrapper"
            controlId="formPlaintextEmail"
          >
            <Form.Control
              className="input-registration"
              maxLength={60}
              type="email"
              placeholder={t("common.email")}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </Form.Group>
          <Form.Group
            className="mb-3 input-registration-wrapper"
            controlId="formPlaintextPassword"
          >
            <InputGroup>
              <Form.Control
                className="input-registration"
                type={showPassword ? "text" : "password"}
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                isInvalid={showErrorPassword}
              />
              <InputGroup.Text
                className="input-registration-toggle"
                onClick={togglePasswordVisibility}
                style={{ cursor: "pointer" }}
              >
                {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
              </InputGroup.Text>
            </InputGroup>

            {showErrorPassword && (
              <div className="field-constraints mt-1">
                <Form.Text className="text-danger">
                  {t("validation.password.constraints")}
                  <ul className="mb-0 mt-1 ps-3">
                    <li>{t("validation.password.characters")}</li>
                    <li>{t("validation.password.uppercase_characters")}</li>
                    <li>{t("validation.password.numbers")}</li>
                    <li>{t("validation.password.special_characters")}</li>
                  </ul>
                </Form.Text>
              </div>
            )}
          </Form.Group>

          <Button
            className="button-registration"
            variant="light"
            size="md"
            type="submit"
            active
          >
            {t("common.next")}
          </Button>
        </Form>
        <div className="back-login-link">
          {t("registration.have_account")}{" "}
          <Link to="../login">{t("registration.login_now")}</Link>
        </div>
      </Stack>
    </Stack>
  );
};

export default Step1;
